/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type School from 'linced-app/models/school';

// Proto: attendance.ResponseActivityConfiguration.
export default class ResponseActivityConfiguration extends Model {
  declare [Type]: 'attendance/response-activity-configuration';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @alias('school.id')
  declare school_id: string | null | undefined;

  // TS-STANDIN(proto attendance.ResponseActivityConfigurationEntry): raw
  // attr holds plain JSON.
  @attr()
  declare configuration: unknown;
}
